import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import { OfflineBanner } from '@/components/organisms/OfflineBanner';

function App() {
  useEffect(() => {
    const handler = (event: MessageEvent<unknown>) => {
      const data = event.data as { type?: string; url?: string } | null;
      if (data?.type === 'SW_NAVIGATE' && typeof data.url === 'string') {
        void router.navigate(data.url);
      }
    };
    navigator.serviceWorker?.addEventListener('message', handler);
    return () => navigator.serviceWorker?.removeEventListener('message', handler);
  }, []);

  return (
    <>
      <OfflineBanner />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
